import Panzoom from "@panzoom/panzoom";
import {useCallback, useRef} from "react";

export function usePanzoom({requireShift = true}: {requireShift?: boolean} = {}) {
  const cleanupRef = useRef<(() => void) | null>(null);

  return useCallback((node: HTMLElement | null) => {
    // React richiama la ref con null quando il viewer viene smontato (ad
    // esempio dopo la creazione della delivery): rimuoviamo prima listener e
    // istanza Panzoom precedenti.
    cleanupRef.current?.();
    cleanupRef.current = null;
    if (!node || !node.parentElement) return;

    const parent = node.parentElement;
    const panzoom = Panzoom(node);
    const wheelListener = (event: WheelEvent) => {
      if (requireShift && !event.shiftKey) return;
      // Evita che un evento rimasto in coda usi un elemento appena smontato.
      if (!node.isConnected || node.parentElement !== parent) return;
      panzoom.zoomWithWheel(event);
    };
    const doubleClickListener = () => {
      if (!node.isConnected || node.parentElement !== parent) return;
      panzoom.reset();
    };
    parent.addEventListener("wheel", wheelListener);
    parent.addEventListener("dblclick", doubleClickListener);

    cleanupRef.current = () => {
      parent.removeEventListener("wheel", wheelListener);
      parent.removeEventListener("dblclick", doubleClickListener);
      panzoom.destroy();
    };
  }, [requireShift]);
}
